$(document).ready(function () {
    // Only apply hover submenu on desktop
    if (window.innerWidth >= 992) {
      // Hover submenu show/hide
      $('.dropdown-submenu').hover(
        function () {
          $(this).children('.dropdown-menu').stop(true, true).fadeIn(200);
        },
        function () {
          $(this).children('.dropdown-menu').stop(true, true).fadeOut(200);
        }
      );
    }

    // Prevent closing first-level dropdown when hovering submenu
    $('.dropdown-menu').on('click', function (e) {
      e.stopPropagation();
    });
  });
//Anterior sin slider automatico  
//  $('#main-slider').owlCarousel({
//    loop:true,
//    margin:0,
//	dots:false,
//    nav:false,
//	animateOut: 'fadeOut',
//    responsive:{
//        0:{
//            items:1
//        },
//        600:{
//            items:1
//        },
//        1000:{
//            items:1
//        }
//    }
//})

$('#main-slider').owlCarousel({
    loop:true,
    margin:0,
    dots:false,
    nav:false,
    animateOut: 'fadeOut',
    autoplay: true,
    autoplayTimeout: 4000,     // ← cambiá este número (en milisegundos)
    autoplayHoverPause: true,  // ← pausa si el mouse está encima
    responsive:{
        0:{ items:1 },
        600:{ items:1 },
        1000:{ items:1 }
    }
})
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.owl-carousel-init').forEach(function (el) {
    const carouselId = el.getAttribute('data-carousel-id');
    $('#' + carouselId).owlCarousel({
      loop: false,
      margin: 30,
      dots: false,
      nav: false,
      responsive: {
        0: { items: 2 },
        600: { items: 2 },
         800: { items: 3 },
        1000: { items: 4 }
      }
    });
  });
});

$(document).ready(function() {
    // Show popup when the link is clicked
    $('.showPopup').click(function() {
    $('.popupBox').show(); // Use fadeIn for smooth visibility
    });

    // Hide popup when the close button is clicked
    $('.closePopup').click(function() {
    $('.popupBox').hide(); // Use fadeOut for smooth disappearance
    });
});
$(document).ready(function() {
    //Surucsales
    $('.sucursales').on('click', function() {

        //setMapOnAll(null);
        var id = $(this).data('id');
        var map_latitude = $(this).data('map_latitude');
        var map_longitude = $(this).data('map_longitude');
        var nombre = $(this).data('nombre');
        var direccion = $(this).data('direccion');
        var telefono = $(this).data('telefono');
        console.log(id + ' ' + map_latitude + ' ' + map_longitude + ' ' + nombre + ' ' + direccion + ' ' + telefono);
        var map = $('#map').data('map');
        map.setCenter(map_latitude, map_longitude);
        map.zoomIn(17 - map.zoom);
        $("html, body").animate({
            scrollTop: 0
        }, "slow");
    });
    
    jQuery(function($) {
        if ($('#map').length === 0) return; 

        var data = $('#map').data();
        var map = new GMaps({
            el: '#map',
            zoom: 10,
            lat: data.lat,
            lng: data.lng
        });
        $('#map').data('map', map);
        //console.log(Cavallaro Express - Julio Correa);
        map.addMarker({
            lat: -25.271029,
            lng: -57.564674,
            title: 'Cavallaro Express - Julio Correa',
            infoWindow: {
                content: "<p><strong>Cavallaro Express - Julio Correa</strong><br/> Julio Correa y Teniente Velázquez<br/>Teléfono(s):  0986 133183</p>"
            }
        });
        //console.log(Cavallaro Express - Santísima Trinidad);
        map.addMarker({
            lat: -25.270796,
            lng: -57.562084,
            title: 'Cavallaro Express - Santísima Trinidad',
            infoWindow: {
                content: "<p><strong>Cavallaro Express - Santísima Trinidad</strong><br/> AVDA. Santisima Trinidad E/ DR. Geronimo Zubizarreta - Paraguay<br/>Teléfono(s):  0981 390050</p>"
            }
        });
        //console.log(Showroom Capiatá);
        map.addMarker({
            lat: -25.375931,
            lng: -57.476440,
            title: 'Showroom Capiatá',
            infoWindow: {
                content: "<p><strong>Showroom Capiatá</strong><br/>Ruta 1 Km. 18 - Capiatá - Paraguay - Paraguay<br/>Teléfono(s): 0981 627369</p>"
            }
        });
        map.addMarker({
            lat: -25.376087,
            lng: -57.476685,
            title: 'Showroom Capiatá 2',
            infoWindow: {
                content: "<p><strong>Showroom Capiatá 2</strong><br/>Ruta 1 Km. 18 - Capiatá - Paraguay - Paraguay<br/>Teléfono(s): 0981 627369</p>"
            }
        });
        //console.log(Cavallaro Express - Mariano Roque Alonso);
        map.addMarker({
            lat: -25.227392,
            lng: -57.534248,
            title: 'Cavallaro Express - Mariano Roque Alonso',
            infoWindow: {
                content: "<p><strong>Cavallaro Express - Mariano Roque Alonso</strong><br/> RUTA TRANSCHACO ESQ. HERNANDARIAS - MARIANO R. ALONSO - PARAGUAY - Paraguay<br/>Teléfono(s):  0981 277318</p>"
            }
        });
        //console.log(Cavallaro Express - Luque);
        map.addMarker({
            lat: -25.265614,
            lng: -57.502403,
            title: 'Cavallaro Express - Luque',
            infoWindow: {
                content: "<p><strong>Cavallaro Express - Luque</strong><br/>Avda Gral Elizardo Aquino e/  Mcal Sucre y San Martín<br/>Teléfono(s): 0981 223162</p>"
            }
        });
 
         map.addMarker({
            lat: -25.30157628978092,
            lng: -57.28510424141542,
            title: 'Cavallaro Express - San Bernardino',
            infoWindow: {
                content: "<p><strong>Cavallaro Express - San Bernardino</strong><br/>Ruta San Bernardino Altos<br/>Teléfono(s): 0985 864924</p>"
            }
        });

    });
});
      

